import React from 'react';
import { Helmet } from 'react-helmet-async';

const OrganizationSchema: React.FC = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "QATE",
    "alternateName": "Quality Assurance Test Engineer",
    "url": "https://qate.ru",
    "logo": "https://qate.ru/logo512.png",
    "description": "AI-powered платформа управления тестированием для автоматизации QA процессов",
    "foundingDate": "2025",
    "industry": "Software Testing",
    "numberOfEmployees": "1-10",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "RU",
      "addressLocality": "Россия"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "customer support",
        "email": "contact@qate.ru",
        "availableLanguage": ["Russian", "English"],
        "areaServed": "RU"
      }
    ],
    "sameAs": [
      "https://t.me/QAappbot"
    ],
    "makesOffer": {
      "@type": "Offer",
      "itemOffered": {
        "@type": "SoftwareApplication",
        "name": "QATE Platform",
        "applicationCategory": "BusinessApplication",
        "operatingSystem": "Web"
      }
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  );
};

export default OrganizationSchema; 